import CheckCircleIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import React from "react";

export default function CrossCandEntry({
    candidate,
    isSelected,
    onWordSelect,
    onWordAdd}) {
    return (
        <ListItem divider disablePadding>
            <Box sx={{ position: 'relative', width: '100%' }}>
                <ListItemButton
                    selected={isSelected}
                    onClick={() => onWordSelect(candidate)}
                    sx={{ pr: 6 }} // Add right padding for the icon button
                >
                    <ListItemText
                        primary={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'nowrap' }}>
                                <Typography variant="h6" component="span" noWrap sx={{ flexShrink: 0 }}>
                                    {candidate.word}
                                </Typography>
                                <Chip
                                    label={candidate.direction}
                                    size="small"
                                    color="primary"
                                    sx={{
                                        flexShrink: 0,
                                        ...(candidate.direction === 'scattered' && {
                                            backgroundColor: '#ce93d8', // MUI purple 200
                                            color: '#4a148c' // purple 900 for contrast
                                        })
                                    }}
                                />
                                <Chip
                                    label={`Score: ${candidate.score || 0}`}
                                    size="small"
                                    color="secondary"
                                    sx={{ flexShrink: 0 }}
                                />
                            </Box>
                        }
                        secondary={
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                Row: {candidate.startRow} | Col: {candidate.startCol} | Direction: {candidate.direction}
                            </Typography>
                        }
                    />
                </ListItemButton>
                
                {/* Add button positioned in top-right corner */}
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        onWordAdd(candidate);
                    }}
                    size="small"
                    color="primary"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8
                    }}
                >
                    <CheckCircleIcon />
                </IconButton>
            </Box>
        </ListItem>
    );
}

